/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Preset_Load_RequiredInputs */

const en_transcript_export_preset_load_required = /** @type {(inputs: Transcript_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need to select a preset!`)
};

const fr_transcript_export_preset_load_required = /** @type {(inputs: Transcript_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous devez selectionner un prereglage !`)
};

const de_transcript_export_preset_load_required = /** @type {(inputs: Transcript_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie müssen eine Voreinstellung auswählen!`)
};

const it_transcript_export_preset_load_required = /** @type {(inputs: Transcript_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devi selezionare un preset!`)
};

const ru_transcript_export_preset_load_required = /** @type {(inputs: Transcript_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вам нужно выбрать предустановленный вариант!`)
};

const es_transcript_export_preset_load_required = /** @type {(inputs: Transcript_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Necesitas seleccionar un ajuste preestablecido!`)
};

const zh_cn2_transcript_export_preset_load_required = /** @type {(inputs: Transcript_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您需要选择一个预设！`)
};

const ja_transcript_export_preset_load_required = /** @type {(inputs: Transcript_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを選択する必要があります。`)
};

const hi_transcript_export_preset_load_required = /** @type {(inputs: Transcript_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपको एक प्रीसेट चुनना होगा!`)
};

const pt_pt2_transcript_export_preset_load_required = /** @type {(inputs: Transcript_Export_Preset_Load_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você precisa selecionar uma predefinição!`)
};

/**
* | output |
* | --- |
* | "You need to select a preset!" |
*
* @param {Transcript_Export_Preset_Load_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_preset_load_required = /** @type {((inputs?: Transcript_Export_Preset_Load_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Preset_Load_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_preset_load_required(inputs)
	if (locale === "de") return de_transcript_export_preset_load_required(inputs)
	if (locale === "it") return it_transcript_export_preset_load_required(inputs)
	if (locale === "ru") return ru_transcript_export_preset_load_required(inputs)
	if (locale === "es") return es_transcript_export_preset_load_required(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_preset_load_required(inputs)
	if (locale === "ja") return ja_transcript_export_preset_load_required(inputs)
	if (locale === "hi") return hi_transcript_export_preset_load_required(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_preset_load_required(inputs)
	return en_transcript_export_preset_load_required(inputs)
});